import { RouteRecordRaw } from 'vue-router';

const rotasModuloPCP: Array<RouteRecordRaw> = [
  {
    path: '/pcp',
    name: 'PCP',
    component: () => import(/* webpackChunkName: "core" */ '@/core/layout/SubLayout.vue'),
    children: [
      {
        path: 'ordem-producao',
        name: 'OrdemProducao',
        meta: {
          titulo: 'Ordem de Produção',
          identificadorRecurso: 'PCP_ORDEM_PRODUCAO',
          identificadorPermissao: 'PER_PCP_ORDEM_PRODUCAO',
        },
        component: () => import(/* webpackChunkName: "ordem-producao" */ '@/views/PCP/OrdemProducao/OrdemProducaoIndex.vue'),
      },
      {
        path: 'processo-producao',
        name: 'ProcessoProducao',
        meta: {
          titulo: 'Processo de Produção',
          identificadorRecurso: 'PCP_ORDEM_PRODUCAO',
          identificadorPermissao: 'PER_PCP_ORDEM_PRODUCAO',
        },
        component: () => import(/* webpackChunkName: "ordem-producao" */ '@/views/PCP/ProcessoProducao/ProcessoProducaoIndex.vue'),
      },
    ],
  },
];

export default rotasModuloPCP;
